import { resolveSemanticColor } from '@/theme/semanticTokens';
import { s } from '@/theme/tokens';
import { Box, Stack, Text } from '@/ui';
import type { ReactElement } from 'react';

type DetectedMappingValuesSectionProps = {
  title: string;
  values: string[];
  isMatched: (value: string) => boolean;
};

export const DetectedMappingValuesSection = ({
  title,
  values,
  isMatched,
}: DetectedMappingValuesSectionProps): ReactElement | null => {
  if (values.length === 0) return null;

  return (
    <Stack gap="xs">
      <Text role="bodyStrong" color="textSecondary">
        {title}
      </Text>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: s('xs') }}>
        {values.map((value, index) => {
          const matched = isMatched(value);
          const suffix = index < values.length - 1 ? ',' : '';
          return (
            <Box key={`${value}-${index}`} component="span" sx={{ display: 'inline-flex' }}>
              <Text
                role="body"
                component="span"
                sx={(theme) => ({
                  color: matched
                    ? resolveSemanticColor(theme, 'success')
                    : resolveSemanticColor(theme, 'textSecondary'),
                  fontWeight: matched ? 600 : 400,
                })}
              >
                {value}
              </Text>
              {suffix ? (
                <Text role="body" component="span" color="textSecondary">
                  {suffix}
                </Text>
              ) : null}
            </Box>
          );
        })}
      </Box>
    </Stack>
  );
};
